// TermsAndConditionsPage.tsx
import React from 'react';

// Define company-specific details (Update these placeholders)
const COMPANY_NAME = " Vermi Compost Barillery";
const EFFECTIVE_DATE = "November 05, 2025";
const CONTACT_EMAIL = "info@vermicompostbarillery.com";
const CONTACT_ADDRESS = "[Delhi-Lucknow Highway near Lalpur Chauraha Barielly]";
// NOTE: I've added a placeholder for the Refund Time Limit in section 3.

const TermsAndConditionsPage: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-50 py-10 px-4 sm:px-6 lg:px-8 font-inter mt-32">
      {/* Container for the content */}
      <div className="max-w-6xl mx-auto bg-white shadow-xl rounded-lg p-8 md:p-12">
        
        {/* Header */}
        <h1 className="text-4xl font-extrabold text-emerald-700 mb-2 border-b-4 border-emerald-100 pb-3">
          📜 Terms and Conditions 
        </h1>
        <p className="text-lg text-gray-600 mb-8">
          <strong>Effective Date:</strong> {EFFECTIVE_DATE}
        </p>

        <p className="text-gray-700 mb-8 leading-relaxed">
          Please read these Terms and Conditions ("Terms") carefully before using our website and services. By using this website, you agree to be bound by all these Terms. If you disagree with any part of these Terms, you must not use the website.
        </p>

        {/* --- 1. General Conditions (सामान्य शर्तें) --- */}
        <section className="mb-10 space-y-4">
          <h2 className="text-2xl font-bold text-gray-800 mb-4 border-l-4 border-emerald-500 pl-3">
            1. General Conditions
          </h2>
          <ul className="list-disc list-outside text-gray-600 space-y-3 ml-4">
            <li>
              Eligibility: To use our services, you must be at least 18 years old or have the consent of your parent/guardian.
            </li>
            <li>
              Changes to Service: {COMPANY_NAME} reserves the right to modify or discontinue its services, product offerings, or website content at any time without prior notice.
            </li>
            <li>
              Errors: Information on our website may contain typographical errors, inaccuracies, or omissions that may relate to product descriptions, pricing, promotions, offers, and availability. We reserve the right to correct any such errors.
            </li>
          </ul>
        </section>

        {/* --- 2. Products and Orders (उत्पाद और आदेश) --- */}
        <section className="mb-10 space-y-4">
          <h2 className="text-2xl font-bold text-gray-800 mb-4 border-l-4 border-emerald-500 pl-3">
            2. Products and Orders
          </h2>
          <ul className="list-disc list-outside text-gray-600 space-y-3 ml-4">
            <li>
              Product Availability: All our vermi compost, vermi beds, and other organic products are subject to stock availability. We reserve the right to limit the sales of any product at any time.
            </li>
            <li>
              Product Variation: Since our products are naturally made (such as vermi compost), there may be slight variations in color, texture, or moisture levels.
            </li>
            <li>
              Pricing: All product prices are subject to change without notice. We reserve the right to refuse or cancel any price error before processing your order.
            </li>
            <li>
              Cancellations: We reserve the right to refuse or cancel any order for any reason, including product or service error, stock shortage, or fraud.
            </li>
          </ul>
        </section>
        
        {/* --- 3. Shipping, Returns, and Refunds (शिपिंग, वापसी और धनवापसी) --- */}
        <section className="mb-10 space-y-4">
          <h2 className="text-2xl font-bold text-gray-800 mb-4 border-l-4 border-emerald-500 pl-3">
            3. Shipping, Returns, and Refunds
          </h2>
          <ul className="list-disc list-outside text-gray-600 space-y-3 ml-4">
            <li>
              Shipping Risk: The risk of product delivery is upon you. Responsibility for damage during shipping will be limited to the extent outlined in our Shipping Policy.
            </li>
            <li>
              Product Returns: Since our products are organic and perishable in nature, they are not eligible for return once delivered, except if the product is delivered damaged or incorrect.
            </li>
            <li>
              Refunds: If a product is found damaged, you must notify us within [Time Limit, e.g., 24 hours] of delivery and provide appropriate photo proof. Refunds will be processed only after our inspection.
            </li>
          </ul>
        </section>

        {/* --- 4. User Account and Conduct (उपयोगकर्ता खाता और आचरण) --- */}
        <section className="mb-10 space-y-4">
          <h2 className="text-2xl font-bold text-gray-800 mb-4 border-l-4 border-emerald-500 pl-3">
            4. User Account and Conduct
          </h2>
          <ul className="list-disc list-outside text-gray-600 space-y-3 ml-4">
            <li>
              Account Security: You are responsible for maintaining the confidentiality of your account password and for all activities that occur under your account.
            </li>
            <li>
              Prohibited Use: You shall not use the website for any unlawful purpose or any purpose prohibited by these Terms.
            </li>
            <li>
              Reviews: If you post any review or feedback on our website, you grant us the right to use, publish, or distribute it royalty-free.
            </li>
          </ul>
        </section>

        {/* --- 5. Limitation of Liability (देयता की सीमा) --- */}
        <section className="mb-10 space-y-4">
          <h2 className="text-2xl font-bold text-gray-800 mb-4 border-l-4 border-emerald-500 pl-3">
            5. Limitation of Liability
          </h2>
          <p className="text-gray-700 leading-relaxed">
            In no event shall {COMPANY_NAME} or its suppliers be liable for any indirect, incidental, special, or consequential damages, including damages arising from improper use of compost or damage to your plants. Our total liability will be limited to the amount paid by you for the product giving rise to the claim.
          </p>
        </section>

        {/* --- 6. Governing Law (शासी कानून) --- */}
        <section className="mb-10 space-y-4">
          <h2 className="text-2xl font-bold text-gray-800 mb-4 border-l-4 border-emerald-500 pl-3">
            6. Governing Law
          </h2>
          <p className="text-gray-700 leading-relaxed">
            These Terms shall be governed by and construed in accordance with the Law of India, without regard to its conflict of law provisions. Any legal action related to these Terms shall be filed exclusively in the courts of [Village Lalpur, near Delhi Lucknow Highway].
          </p>
        </section>

        {/* --- 7. Contact Information (संपर्क जानकारी) --- */}
        <section className="space-y-4">
          <h2 className="text-2xl font-bold text-gray-800 mb-4 border-l-4 border-emerald-500 pl-3">
            7. Contact Information
          </h2>
          <p className="text-gray-700">
            If you have any questions about these Terms and Conditions, you may contact us:
          </p>
          
          <div className="bg-emerald-50 border border-emerald-200 p-4 rounded-lg space-y-2">
            <p className="text-gray-800">
              <span className="font-semibold">By Email:</span> <a href={`mailto:${CONTACT_EMAIL}`} className="text-blue-600 hover:underline">{CONTACT_EMAIL}</a>
            </p>
            <p className="text-gray-800">
              <span className="font-semibold">By Mail:</span> {CONTACT_ADDRESS}
            </p>
          </div>
        </section>

      </div>
    </div>
  );
};

export default TermsAndConditionsPage;